/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type { DesktopApp } from './types';
import type { DesktopWindowState } from './windowSystem';

const DEFAULT_WINDOW_IS_MAXIMIZED = true;
/** Per-app defaults from v4. */
const APP_WINDOW_DEFAULTS: Record<
  string,
  {
    width: number;
    height: number;
    maximized: boolean;
    /** Smallest size the app is usable at, when larger than any window's minimum. */
    minWidth?: number;
    minHeight?: number;
  }
> = {
  pvsim: { width: 820, height: 560, maximized: true },
  database: { width: 1500, height: 800, maximized: false },
  'system-issues': { width: 1180, height: 640, maximized: false },
  settings: { width: 920, height: 680, maximized: false },
};
export const MIN_WINDOW_WIDTH = 280;
/**
 * Narrower bounds mean the desktop is covered (e.g. the Agent full screen) or not laid out yet,
 * not resized: windows and tiles keep their geometry instead of fitting to it.
 */
export const MIN_FIT_WIDTH = 320;
export const MIN_WINDOW_HEIGHT = 220;
export const getMinWindowSize = (appId: string) => ({
  width: Math.max(MIN_WINDOW_WIDTH, APP_WINDOW_DEFAULTS[appId]?.minWidth ?? 0),
  height: Math.max(MIN_WINDOW_HEIGHT, APP_WINDOW_DEFAULTS[appId]?.minHeight ?? 0),
});
export const isMaximizedByDefault = (id: string) =>
  APP_WINDOW_DEFAULTS[id]?.maximized ?? DEFAULT_WINDOW_IS_MAXIMIZED;
export const getDefaultWindowMetrics = (
  id: string,
  apps: readonly DesktopApp[],
): Pick<DesktopWindowState, 'x' | 'y' | 'width' | 'height'> => {
  const defaults = APP_WINDOW_DEFAULTS[id];
  const index = Math.max(
    0,
    apps.findIndex((app) => app.id === id),
  );
  return {
    x: 48 + (index % 4) * 36,
    y: 56 + (index % 4) * 30,
    width: defaults?.width ?? 380,
    height: defaults?.height ?? 260,
  };
};
